import { Chip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { HoverModal } from '../hoverModal';
import { MPubCardSimple } from '../mPubCard';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AjaxFunctions = require('../../ajaxFunctions');
const SharedModels = require('../../../../../shared/sharedModels');
const moment = require('moment');
const SharedConstants = require('../../../../../shared/sharedConstants');

export default function Round(props) {
    let { matchData, idRound, bracketData, numMatches, side, title, isChampionship, isFinal, className, topClass, bottomClass, editMode, disableLink, forceShowScore} = props;
    let offset = (side == 'left') ? 0 : parseInt(numMatches);
    let [items, setItems] = useState({ groupedItems: {}, regularItems: [] });
    let [isDragging, setIsDragging] = useState(false);
    let date = bracketData[`round${idRound}EndTime`];

    useEffect(() => {
        setItems(getItems(editMode, disableLink, matchData, idRound, bracketData, numMatches, side, isChampionship, isFinal, topClass, bottomClass));
        if(forceShowScore) bracketData.showScore = true;
    }, [props]);

    let onDragEnd = async (result) => {
        if (!result.destination) {
            return;
        }
        const reorder = (list, startIndex, endIndex) => {
            const result = Array.from(list);
            const [removed] = result.splice(startIndex, 1);
            result.splice(endIndex, 0, removed);
            return { result, removed };
        };
        const newItems = reorder(
            items.regularItems,
            result.source.index,
            result.destination.index
        );

        if (result.destination.droppableId == 'dropTrash') {
            let { card } = newItems.removed;
            try {
                await AjaxFunctions.removeCardFromPortfolio(bracketData.idIncubator, card.id, card.cardType)
            } catch (err) {
                console.log("Error removing bracket item", err)
            }
            return;
        }
        try {
            await AjaxFunctions.updateBracketPositions(bracketData.idIncubator, bracketData.idBracket, newItems.result, offset)
        } catch (err) {
            console.log("Error updating bracket positions", err)
        }
    }

    return (
        <div className={className}>
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="dropTrash">
                    {(provided, snapshot) => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                            {isDragging && <Chip label="Drag To Delete" style={{ width: '100%', backgroundColor: snapshot.isDraggingOver ? '#C0EEEE' : '#E2EEEE' }} />}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
                <div className="round-details">{title}<br /><span className="date">{moment.utc(date).format('l')}</span></div>
                <Droppable droppableId="dropCardList">
                    {(provided, snapshot) => {
                        setIsDragging(snapshot.draggingFromThisWith)
                        return (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {Object.keys(items.groupedItems).map((i) => {
                                    let item = items.groupedItems[i];
                                    let top = item[0] || null;
                                    let bottom = item[1] || null;
                                    return (
                                        <ul key={i} className={`matchup ${isChampionship ? 'championship' : ''} `}>
                                            {top && top.content}
                                            {bottom && bottom.content}
                                        </ul>
                                    )
                                })}
                                {provided.placeholder}
                            </div>
                        )
                    }}
                </Droppable>
            </DragDropContext>
        </div>

    );
}

function bracketCategory(idCategory) {
    switch (idCategory) {
        case SharedConstants.BracketCategory.TopLeftBracket.id:
            return { className: "topLeftBracket", name: SharedConstants.BracketCategory.TopLeftBracket.name };
        case SharedConstants.BracketCategory.BottomLeftBracket.id:
            return { className: "bottomLeftBracket", name: SharedConstants.BracketCategory.BottomLeftBracket.name };
        case SharedConstants.BracketCategory.TopRightBracket.id:
            return { className: "topRightBracket", name: SharedConstants.BracketCategory.TopRightBracket.name };
        case SharedConstants.BracketCategory.BottomRightBracket.id:
            return { className: "bottomRightBracket", name: SharedConstants.BracketCategory.BottomRightBracket.name };
    }
}

const getItems = (editMode, disableLink, matchData, idRound, bracketData, numMatches, side, isChampionship, isFinal, topClass, bottomClass, arr) => {
    let groupBy = (key, array) => {
        return array.reduce((objectsByKeyValue, obj) => {
            const value = obj[key];
            objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
            return objectsByKeyValue;
        }, {}
        );
    }
    let isOnSide = (item) => {
        if (isFinal) return true;
        let idMatch = parseInt(item.idMatch)
        if (side == 'left') {
            return (idMatch >= 1 && idMatch <= (numMatches / 2))
        } else {
            return (idMatch > (numMatches / 2) && idMatch <= numMatches)
        }
    }
    let winType = (curItem, otherItem) => {
        if (parseInt(bracketData.currentRound) <= idRound) {
            return ""
        }
        let curItemScore = curItem ? curItem.score || 0 : -1;
        let otherItemScore = otherItem ? otherItem.score || 0 : -1;
        if (curItemScore > otherItemScore) {
            return "winner"
        } else if (curItemScore == otherItemScore) {
            return "tie"
        } else if (curItemScore < otherItemScore) {
            return "loser"
        }
    }

    let groupedItems = groupBy('idMatch', matchData.filter(b => b.idRound == idRound && isOnSide(b)));
    let roundItems = arr ? arr : [...Array((parseInt(numMatches / 2))).keys()].map(k => {
        let index = k + 1 + (side == "right" ? parseInt(numMatches / 2) : 0);
        let firstCard = groupedItems[index] ? (groupedItems[index][0] ? groupedItems[index][0] : null) : null;
        let secondCard = groupedItems[index] ? (groupedItems[index][1] ? groupedItems[index][1] : null) : null;
        return [{ card: firstCard, other: secondCard }, { card: secondCard, other: firstCard }]
    }).flat();

    let mappedItems = roundItems.map((cardObject, i) => {
        let { card, other } = cardObject;
        let isOnTop = (i % 2) == 0, group = (i / 2) >> 0;
        let bracketClass = (i < (parseInt(numMatches) / 2)) ? topClass : bottomClass;
        if (card || ((card && !other) || (!card && other))) {
            let curBracketItem =
               <BracketItem
                  disableLink={disableLink}
                  bracketData={bracketData}
                  position={isOnTop ? "top" : "bottom"}
                  card={card}
                  winType={winType(card, other)}
                  className={isChampionship ? topClass : bracketClass}
               />;
            return ({
                group, id: i, content: editMode ? <Draggable draggableId={`${i}`} index={i} key={i}>
                    {(provided) => (
                        <div
                           className={'draggable-item'}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                        >
                            {curBracketItem}
                        </div>
                    )}
                </Draggable> : curBracketItem
            })
        } else {
            return { group, id: i, content: <li key={i} className={`team team-top ${bracketClass}`}>&nbsp;</li> }
        }
    });
    return { groupedItems: groupBy('group', mappedItems), regularItems: roundItems };
}

function BracketItem(props) {
    let { card, bracketData, position, winType, className, disableLink } = props;

    let showScore = bracketData.showScore ? true : false;
    if (!card) return <li className={`team team-${position} ${className}`}></li>
    let formattedCard = SharedModels.formatGenericCard(props.card);

    let numNewComments = 0;
    if(formattedCard.comments.length > 0){
        for(let comment of formattedCard.comments){
            if(comment.minutesSinceCreation < 2880) { //60 min * 24 * 2
                numNewComments++;
            }
        }
    }

    return (
        <HoverModal
            linkTo={disableLink 
                ? null 
                : `/incubator?idIncubator=${bracketData.idIncubator}&initialTab=madness&cardType=${card.cardType}&idCard=${card.id}&idSubmitter=${card.idSubmitter}&cModalOpen=1`
            }
            className={'modal-' + bracketCategory(card.idCategory).className}
            textTitle={
                <li
                   className={`team team-${position} ${winType} ${bracketCategory(card.idCategory).className}`}
                >
                    <span style={{ marginRight: '10px' }}>
                        {card.bracketTitle || card.title.substring(0, 255)}
                    </span>
                    {showScore && <span className="score">{card.score || 0}</span>}
                    {
                        numNewComments > 0 &&
                        <span className={'comment-notification'}>
                            <FontAwesomeIcon
                               size='sm'
                               icon={['far', 'comment']}
                            />
                        </span>
                    }
                </li>
            }
            titleStyle={{ fontSize: 14, color: '#4457CF' }}
            cardContent={
                <div>
                    <MPubCardSimple disableLink card={formattedCard} />
                    <div className={'round-hover-modal-click-text'}>
                        Click To Comment On This Transformation {numNewComments > 0 && `(${numNewComments} Recent)`}
                    </div>
                </div>
            }
            hoverAnchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            hoverTransformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            maxWidth={'100%'}
        />
    );
}